import React from 'react';
import { InputMask } from '@react-input/mask';
import { Form } from 'react-bootstrap'; // Assuming you're using react-bootstrap


function PhoneInput({label, value, onChange, id = "control-phone", error, isErrorText=true}){

    return(
        <div className="form-group" id={id}>
          <Form.Label>{label}</Form.Label>
          <InputMask
            mask="+38(___) ___-____" // Example mask for phone number
            replacement={{ _: /\d/ }} // Define what '9' represents (a digit)
            value={value}
            onChange={onChange}
            alwaysShowMask={true}
            placeholder="+380(XX) XXX-XXXX"
            className={`form-control ${error? 'is-invalid' : ''}`}
            render={(inputProps) => (
              <Form.Control
                {...inputProps}
                type="text" // Ensure type is "text" for proper masking
                
              />
            )}
          />
          {isErrorText && error && <div className="invalid-feedback">{error}</div>}
      </div>
    )

};

export default PhoneInput;